import CardContent from "@mui/joy/CardContent";
import CardOverflow from "@mui/joy/CardOverflow";
import CardActions from "@mui/joy/CardActions";
import Button from "@mui/joy/Button";
import React from "react";
import Box from '@mui/material/Box';
import {useSelector} from "react-redux";
import {URLMaker} from "../utils/helpers";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Carousel from 'react-material-ui-carousel'
import TextField from "@mui/material/TextField";


const ShareModal = ({shareUrl, handlePublicChange, handleShare, checked, isLoading}) => {
    return (
        <>
            <CardContent sx={{maxWidth: '40ch'}}>
                Create a public view link to allow anyone to access a view-only version of this design, no
                sign-in required.
            </CardContent>
            <CardOverflow>
                <SwipeableTextMobileStepper/>
            </CardOverflow>

            <TextField
                variant="outlined"
                InputProps={{
                    readOnly: true,
                    style: { backgroundColor: '#f0f0f0', width: '100%', padding: '10px' },
                }}
                value={shareUrl}
                sx={{
                    width:'100%',
                    '& .MuiOutlinedInput-root': {
                        '& input': {
                            padding: 0,
                        },
                        '& fieldset': {
                            borderColor: 'transparent',
                        },
                        '&:hover fieldset': {
                            borderColor: 'transparent',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'transparent',
                        },
                    },
                }}
            />
            <CardActions>
                <FormControlLabel
                    label={"Public"}
                    control={
                        <Checkbox
                            checked={!checked}
                            onChange={(e)=>{handlePublicChange(e.target.checked)}}
                        />
                    }
                />
                <Button disabled={isLoading} onClick={handleShare}>
                    Copy link
                </Button>
            </CardActions>
        </>
    )
}
export default ShareModal

function SwipeableTextMobileStepper() {
    const {shareImages} = useSelector((state) => state.loginSlice);

    return (
        <Box sx={{maxWidth: 400, flexGrow: 1}}>

            <Carousel>
                {
                    Object.values(shareImages)?.map( (item, i) => {
                        return(
                            <Box sx={{display:"flex", justifyContent:"center"}} key={i}>
                                <img height={200} width={'auto'} src={URLMaker(item)}/>
                            </Box>
                        )
                    })
                }
            </Carousel>
        </Box>
    );
}